// @core/api/endpoints/project/delete_label.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/project';

/**
 * Delete label
 * Deletes a label from the project. The label is automatically removed from all items.
 */
export async function DeleteLabel(
  project_id: string,
  label_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id/labels/:label_id`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  requestPath = requestPath.replace(':label_id', encodeURIComponent(label_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
